import { Seo } from '../components/Seo';
import { Reveal } from '../components/Reveal';
import { CtaBand } from '../components/CtaBand';
import { SIGNATURE_COCKTAILS } from '../lib/brand';

export function CocktailMenuPage() {
  return (
    <div className="tm-page">
      <Seo
        title="칵테일 & 메뉴 | 타로맨스"
        description="메이저 아르카나를 재해석한 시그니처 아르카나 컬렉션과 커스텀 칵테일. 타로맨스의 메뉴를 소개합니다."
      />

      <section className="tm-page-hero">
        <div className="tm-container">
          <Reveal>
            <p className="tm-eyebrow">Cocktail & Menu</p>
            <h1 className="tm-display">
              카드의 상징을 담은
              <br />
              <em>시그니처 아르카나 컬렉션</em>
            </h1>
            <p className="tm-lede">
              메뉴판을 먼저 내밀지 않습니다. 취향과 대화의 흐름을 듣고, 그날의 카드처럼 어울리는 한 잔을 제안합니다.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="tm-section">
        <div className="tm-container">
          <Reveal>
            <div className="tm-hub-head">
              <div>
                <p className="tm-eyebrow">Signature</p>
                <h2 className="tm-h2">메이저 아르카나, 잔에 담기다</h2>
              </div>
            </div>
          </Reveal>
          <div className="tm-menu-grid">
            {SIGNATURE_COCKTAILS.map((cocktail, index) => (
              <Reveal key={cocktail.name} className="tm-menu-card" delay={(index % 3) * 70}>
                <figure>
                  <img src={cocktail.image} alt={`${cocktail.name} 칵테일`} loading="lazy" />
                </figure>
                <div>
                  <div className="tm-menu-card-title">
                    <h3>{cocktail.name}</h3>
                    <span>{cocktail.nameKo} · {cocktail.arcana}</span>
                  </div>
                  <p className="tm-body-text" style={{ marginTop: 8 }}>{cocktail.description}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="tm-section tm-section--line tm-section--deep">
        <div className="tm-container">
          <div className="tm-split">
            <Reveal>
              <p className="tm-eyebrow">Price Guide</p>
              <h2 className="tm-h2">가격 안내</h2>
              <p className="tm-lede">
                모든 가격은 범위로 안내드리며, 자세한 메뉴와 가격은 매장에서 확인하실 수 있습니다.
              </p>
            </Reveal>
            <Reveal delay={100}>
              <table className="tm-price-table">
                <tbody>
                  <tr>
                    <th>시그니처 칵테일</th>
                    <td>아르카나 컬렉션</td>
                    <td>23,000 – 25,000원</td>
                  </tr>
                  <tr>
                    <th>클래식 · 일반 칵테일</th>
                    <td>취향에 맞춰 제안</td>
                    <td>19,000 – 21,000원</td>
                  </tr>
                  <tr>
                    <th>커스텀 칵테일</th>
                    <td>대화와 리딩의 분위기에 맞춘 한 잔</td>
                    <td>매장 안내</td>
                  </tr>
                  <tr>
                    <th>논알코올</th>
                    <td>비음주 고객을 위한 메뉴</td>
                    <td>매장 안내</td>
                  </tr>
                </tbody>
              </table>
              <ul className="tm-note-list" style={{ marginTop: 28 }}>
                <li>주방이 없는 바 공간으로, 칵테일과 간단한 안주 중심으로 운영됩니다.</li>
                <li>1인 커버차지가 있습니다. 자세한 내용은 예약 시 안내드립니다.</li>
                <li>비음주 방문도 환영합니다. 논알코올 메뉴와 함께 상담을 이용해 보세요.</li>
              </ul>
            </Reveal>
          </div>
        </div>
      </section>

      <CtaBand title="당신의 카드에 어울리는 한 잔을 준비해 두겠습니다." secondaryLabel="타로 상담 안내" secondaryTo="/tarot-consultation" />
    </div>
  );
}
